/**
 * Book Your 15-Minute Call – multi-step booking form
 */
( function() {
	const container = document.querySelector( '.book-your-call' );
	if ( ! container ) {
		return;
	}

	let currentStep = 1;
	let selectedDate = '';
	let selectedTime = '';
	let calendarMonth = new Date().getMonth();
	let calendarYear = new Date().getFullYear();

	const stepCounter = document.getElementById( 'byc-step-counter' );
	const stepperSteps = container.querySelectorAll( '.byc-step' );
	const stepperLines = container.querySelectorAll( '.byc-step-line' );
	const sections = container.querySelectorAll( '.byc-section' );
	const dateInput = container.querySelector( '#byc-date-input' );
	const dateField = container.querySelector( '.byc-date-field' );
	const dateTrigger = container.querySelector( '.byc-date-trigger' );
	const dateDisplay = container.querySelector( '.byc-date-display' );
	const calendar = container.querySelector( '.byc-calendar' );
	const calMonthYear = container.querySelector( '.byc-cal-month-year' );
	const calDays = container.querySelector( '.byc-calendar-days' );
	const calPrev = container.querySelector( '.byc-cal-prev' );
	const calNext = container.querySelector( '.byc-cal-next' );
	const timeSlots = container.querySelectorAll( '.byc-time-slot' );
	const detailsPlaceholder = container.querySelector( '.byc-details-placeholder' );
	const detailsFields = container.querySelector( '.byc-details-fields' );
	const nameInput = container.querySelector( '#byc-name' );
	const emailInput = container.querySelector( '#byc-email' );
	const submitBtn = container.querySelector( '.byc-submit' );
	const form = container.querySelector( '.byc-form' );

	const today = new Date();
	today.setHours( 0, 0, 0, 0 );

	const monthNames = [
		'January', 'February', 'March', 'April', 'May', 'June',
		'July', 'August', 'September', 'October', 'November', 'December',
	];

	function formatDate( dateStr ) {
		const date = new Date( dateStr + 'T00:00:00' );
		return date.toLocaleDateString( 'en-US', {
			month: 'long',
			day: 'numeric',
			year: 'numeric',
		} );
	}

	function toDateStr( year, month, day ) {
		const m = String( month + 1 ).padStart( 2, '0' );
		const d = String( day ).padStart( 2, '0' );
		return year + '-' + m + '-' + d;
	}

	function isValidEmail( email ) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( email );
	}

	function updateStepper( step ) {
		stepperSteps.forEach( ( el ) => {
			const stepNum = parseInt( el.dataset.step, 10 );
			el.classList.remove( 'is-complete', 'is-active', 'is-pending' );
			if ( stepNum < step ) {
				el.classList.add( 'is-complete' );
			} else if ( stepNum === step ) {
				el.classList.add( 'is-active' );
			} else {
				el.classList.add( 'is-pending' );
			}
		} );

		stepperLines.forEach( ( line, index ) => {
			line.classList.toggle( 'is-complete', index < step - 1 );
		} );
	}

	function updateSections( step ) {
		sections.forEach( ( section ) => {
			const sectionNum = parseInt( section.dataset.section, 10 );
			section.classList.remove( 'is-active', 'is-complete', 'is-disabled' );
			if ( sectionNum < step ) {
				section.classList.add( 'is-complete' );
			} else if ( sectionNum === step ) {
				section.classList.add( 'is-active' );
			} else {
				section.classList.add( 'is-disabled' );
			}
		} );

		if ( step >= 3 ) {
			if ( detailsPlaceholder ) {
				detailsPlaceholder.style.display = 'none';
			}
			if ( detailsFields ) {
				detailsFields.style.display = 'flex';
			}
		} else {
			if ( detailsPlaceholder ) {
				detailsPlaceholder.style.display = 'block';
			}
			if ( detailsFields ) {
				detailsFields.style.display = 'none';
			}
		}
	}

	function updateButton() {
		if ( ! submitBtn ) {
			return;
		}

		submitBtn.style.display = '';
		submitBtn.textContent = 'Book My Call \u2192';

		if ( currentStep < 3 ) {
			submitBtn.disabled = true;
			submitBtn.classList.remove( 'is-ready' );
			return;
		}

		const isValid = nameInput && emailInput &&
			nameInput.value.trim() !== '' &&
			isValidEmail( emailInput.value.trim() );
		submitBtn.disabled = ! isValid;
		submitBtn.classList.toggle( 'is-ready', isValid );
	}

	function goToStep( step ) {
		currentStep = step;
		if ( stepCounter ) {
			stepCounter.textContent = 'Step ' + step + ' of 3';
		}
		updateStepper( step );
		updateSections( step );
		updateButton();

		if ( step === 3 && nameInput ) {
			setTimeout( function() {
				nameInput.focus();
			}, 350 );
		}
	}

	function setSelectedDate( dateStr ) {
		selectedDate = dateStr;
		if ( dateInput ) {
			dateInput.value = dateStr;
		}
		if ( dateDisplay ) {
			dateDisplay.textContent = formatDate( dateStr );
			dateDisplay.classList.add( 'has-value' );
		}
		updateButton();

		if ( currentStep === 1 ) {
			closeCalendar();
			setTimeout( function() {
				goToStep( 2 );
			}, 300 );
		}
	}

	function renderCalendar() {
		if ( ! calDays || ! calMonthYear ) {
			return;
		}

		calMonthYear.textContent = monthNames[ calendarMonth ] + ' ' + calendarYear;
		calDays.innerHTML = '';

		const firstDay = new Date( calendarYear, calendarMonth, 1 ).getDay();
		const daysInMonth = new Date( calendarYear, calendarMonth + 1, 0 ).getDate();

		for ( let i = 0; i < firstDay; i++ ) {
			const empty = document.createElement( 'button' );
			empty.type = 'button';
			empty.className = 'byc-cal-day is-empty';
			empty.disabled = true;
			empty.textContent = '0';
			calDays.appendChild( empty );
		}

		for ( let day = 1; day <= daysInMonth; day++ ) {
			const dateStr = toDateStr( calendarYear, calendarMonth, day );
			const dateObj = new Date( calendarYear, calendarMonth, day );
			const btn = document.createElement( 'button' );
			btn.type = 'button';
			btn.className = 'byc-cal-day';
			btn.textContent = String( day );
			btn.dataset.date = dateStr;

			if ( dateObj < today ) {
				btn.classList.add( 'is-past' );
				btn.disabled = true;
			}

			if ( dateObj.getTime() === today.getTime() ) {
				btn.classList.add( 'is-today' );
			}

			if ( dateStr === selectedDate ) {
				btn.classList.add( 'is-selected' );
			}

			btn.addEventListener( 'click', function() {
				setSelectedDate( dateStr );
				renderCalendar();
			} );

			calDays.appendChild( btn );
		}
	}

	function openCalendar() {
		if ( ! calendar || ! dateTrigger ) {
			return;
		}

		if ( selectedDate ) {
			const parts = selectedDate.split( '-' );
			calendarYear = parseInt( parts[ 0 ], 10 );
			calendarMonth = parseInt( parts[ 1 ], 10 ) - 1;
		} else {
			calendarMonth = today.getMonth();
			calendarYear = today.getFullYear();
		}

		renderCalendar();
		calendar.hidden = false;
		dateTrigger.classList.add( 'is-open' );
		dateTrigger.setAttribute( 'aria-expanded', 'true' );
		if ( dateField ) {
			dateField.classList.add( 'is-calendar-open' );
		}
	}

	function closeCalendar() {
		if ( ! calendar || ! dateTrigger ) {
			return;
		}
		calendar.hidden = true;
		dateTrigger.classList.remove( 'is-open' );
		dateTrigger.setAttribute( 'aria-expanded', 'false' );
		if ( dateField ) {
			dateField.classList.remove( 'is-calendar-open' );
		}
	}

	function toggleCalendar() {
		if ( calendar && calendar.hidden ) {
			openCalendar();
		} else {
			closeCalendar();
		}
	}

	if ( dateTrigger ) {
		dateTrigger.addEventListener( 'click', function( event ) {
			event.preventDefault();
			event.stopPropagation();
			toggleCalendar();
		} );
	}

	if ( calPrev ) {
		calPrev.addEventListener( 'click', function( event ) {
			event.stopPropagation();
			calendarMonth--;
			if ( calendarMonth < 0 ) {
				calendarMonth = 11;
				calendarYear--;
			}
			renderCalendar();
		} );
	}

	if ( calNext ) {
		calNext.addEventListener( 'click', function( event ) {
			event.stopPropagation();
			calendarMonth++;
			if ( calendarMonth > 11 ) {
				calendarMonth = 0;
				calendarYear++;
			}
			renderCalendar();
		} );
	}

	document.addEventListener( 'click', function( event ) {
		if ( calendar && ! calendar.hidden ) {
			const dateField = container.querySelector( '.byc-date-field' );
			if ( dateField && ! dateField.contains( event.target ) ) {
				closeCalendar();
			}
		}
	} );

	timeSlots.forEach( ( slot ) => {
		slot.addEventListener( 'click', function() {
			if ( currentStep < 2 ) {
				return;
			}
			timeSlots.forEach( ( s ) => s.classList.remove( 'is-selected' ) );
			this.classList.add( 'is-selected' );
			selectedTime = this.dataset.time;
			updateButton();

			if ( currentStep === 2 ) {
				setTimeout( function() {
					goToStep( 3 );
				}, 300 );
			}
		} );
	} );

	if ( nameInput ) {
		nameInput.addEventListener( 'input', updateButton );
	}
	if ( emailInput ) {
		emailInput.addEventListener( 'input', updateButton );
	}

	if ( form ) {
		form.addEventListener( 'submit', function( event ) {
			event.preventDefault();

			if ( currentStep !== 3 ) {
				return;
			}

			const name = nameInput ? nameInput.value.trim() : '';
			const email = emailInput ? emailInput.value.trim() : '';
			if ( name && isValidEmail( email ) ) {
				submitBtn.disabled = true;
				submitBtn.textContent = 'Booking...';
				setTimeout( function() {
					alert(
						'Your call has been booked!\n\nDate: ' + formatDate( selectedDate ) +
						'\nTime: ' + selectedTime +
						'\nName: ' + name +
						'\nEmail: ' + email
					);
					form.reset();
					selectedDate = '';
					selectedTime = '';
					timeSlots.forEach( ( s ) => s.classList.remove( 'is-selected' ) );
					if ( dateDisplay ) {
						dateDisplay.textContent = 'Select a date';
						dateDisplay.classList.remove( 'has-value' );
					}
					if ( dateInput ) {
						dateInput.value = '';
					}
					goToStep( 1 );
				}, 800 );
			}
		} );
	}

	goToStep( 1 );
} )();
